var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExameImagem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.a-imagem{fill:none;}.b-imagem{isolation:isolate;clip-path:url(#a);}.c-imagem{fill:#fdeab6;}.d-imagem{fill:#454f63;}\n\t\t"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a-imagem",
    x: 2,
    y: 2,
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b-imagem",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35 -570)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c-imagem",
    d: "M31.96,21a10.96,10.96,0,1,0,10.96,10.96A10.96,10.96,0,0,0,31.96,21Z",
    transform: "translate(31.439 564.438)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-imagem",
    d: "M23.788,411.244H18.529a1.278,1.278,0,0,0-1.277,1.277v.075H1.882a.881.881,0,0,1,0-1.761H5.726a.5.5,0,0,0,0-1H1.882a1.882,1.882,0,0,0,0,3.764h15.37v.075a1.278,1.278,0,0,0,1.277,1.277h5.258a1.853,1.853,0,1,0,0-3.706Zm-1.352,2.7H18.529a.276.276,0,0,1-.275-.275v-1.152a.276.276,0,0,1,.275-.275h3.906Zm1.352,0h-.351v-1.7h.351a.851.851,0,0,1,0,1.7Z",
    transform: "translate(0 -409.833)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.395 20.524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-imagem",
    d: "M148.525,409.977a.5.5,0,1,0,.147.354A.5.5,0,0,0,148.525,409.977Z",
    transform: "translate(-147.67 -409.83)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.285 8.163)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-imagem",
    d: "M445.855,163.147a.5.5,0,1,0,.147.354A.5.5,0,0,0,445.855,163.147Z",
    transform: "translate(-445 -163)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.354)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-imagem",
    d: "M67.432,6.911a.5.5,0,0,0,.5-.5V2.5a2.507,2.507,0,0,0-2.5-2.5H49.5A2.507,2.507,0,0,0,47,2.5v12.72a2.507,2.507,0,0,0,2.5,2.5h5.459V19.21a1.9,1.9,0,0,0-1.35,1.815v.609a.5.5,0,0,0,.5.5H60.82a.5.5,0,0,0,.5-.5v-.609a1.9,1.9,0,0,0-1.35-1.815V17.728h5.459a2.507,2.507,0,0,0,2.5-2.5V10.7a.5.5,0,0,0-1,0v4.524a1.5,1.5,0,0,1-1.5,1.5H49.5a1.5,1.5,0,0,1-1.5-1.5V2.5A1.5,1.5,0,0,1,49.5,1H65.429a1.5,1.5,0,0,1,1.5,1.5V6.41A.5.5,0,0,0,67.432,6.911ZM55.964,17.728h3v1.4h-3Zm3.462,2.4a.894.894,0,0,1,.893.893v.109h-5.7v-.109a.894.894,0,0,1,.893-.893Z",
    transform: "translate(-47)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.357 2.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-imagem",
    d: "M102.925,40H88a1,1,0,0,0-1,1V52.72a1,1,0,0,0,1,1h14.924a1,1,0,0,0,1-1V41A1,1,0,0,0,102.925,40Zm0,12.72H88V41h14.924V52.72Z",
    transform: "translate(-87 -40)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.364 4.793)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-imagem",
    d: "M139.875,100.8l-3.864-4.91a.5.5,0,0,0-.634-.13,3.9,3.9,0,0,1-3.7,0,.5.5,0,0,0-.634.13l-3.864,4.91a.5.5,0,0,0,.039.664,8.934,8.934,0,0,0,12.62,0A.5.5,0,0,0,139.875,100.8Zm-11.629.26,3.331-4.233a4.922,4.922,0,0,0,3.9,0l3.331,4.233A7.934,7.934,0,0,1,128.246,101.062Z",
    transform: "translate(-127.069 -95.701)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.36 4.006)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-imagem",
    d: "M129.27,80H127.5a.5.5,0,0,0,0,1h1.769a.5.5,0,1,0,0-1Z",
    transform: "translate(-127 -80)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.36 5.909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-imagem",
    d: "M127.855,118.147a.5.5,0,1,0,.147.354A.5.5,0,0,0,127.855,118.147Z",
    transform: "translate(-127 -118)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExameImagem);
export default __webpack_public_path__ + "static/media/exame-imagem.df94f9dc.svg";
export { ForwardRef as ReactComponent };